var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCenterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM11.7 16.5C12.1142 16.5 12.45 16.8358 12.45 17.25C12.45 17.6642 12.1142 18 11.7 18C11.2858 18 10.95 17.6642 10.95 17.25C10.95 16.8358 11.2858 16.5 11.7 16.5ZM11.7 6C13.7183 6 15.3545 7.63618 15.3545 9.6545C15.3545 11.3473 14.2036 12.7713 12.6415 13.1866L12.449 13.231L12.45 14.4611C12.45 14.8407 12.1678 15.1545 11.8018 15.2042L11.7 15.2111C11.3203 15.2111 11.0065 14.9289 10.9568 14.5628L10.95 14.4611V12.559C10.95 12.1448 11.2858 11.809 11.7 11.809C12.8899 11.809 13.8545 10.8444 13.8545 9.6545C13.8545 8.4646 12.8899 7.5 11.7 7.5C10.6878 7.5 9.81798 8.20395 9.59831 9.17756C9.50714 9.58161 9.10568 9.83526 8.70162 9.74409C8.29757 9.65292 8.04392 9.25146 8.13509 8.84741C8.5083 7.19335 9.98286 6 11.7 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenterIcon);
export default __webpack_public_path__ + "static/media/HelpCenterIcon.24368184ac5a7abfb110c804efb1ae3e.svg";
export { ForwardRef as ReactComponent };